import React from 'react';
import MuiDialog from "../../../atoms/muiDialog";
import {Button, Typography, Divider} from "@material-ui/core";
import HelpIcon from '@material-ui/icons/Help';
import {css} from "@emotion/react";

// setting
import colorPalette from "../../../../styles/theme/colorPalette"
import {makeStyles} from "@material-ui/styles";

const Care = () => {
  
  const [open, setOpen] = React.useState(false);
  
  const handleClose = (value) => {
    setOpen(false);
  };
  
  const handleClickOpen = () => {
    setOpen(true);
  };
  
  const useStyles = makeStyles({
    dialogPaper: {
      borderRadius: '24px',
      square: false
    },
  })
  
  const classes = useStyles()
  
  return (
      <>
        <HelpIcon color='primary' onClick={handleClickOpen} css={cursor}/>
        <MuiDialog
            onClose={handleClose}
            open={open}
            fullWidth={true}
            maxWidth='lg'
            css={dialogStyle}
            closeBtnColor={colorPalette.itemCategories.care}
            classes={{paper: classes.dialogPaper}}>
          <div css={innerBox}>
            <hr css={style}/>
            <p css={title}>ケア食・その他</p>
            <p css={subTitle}>
              咀嚼が困難な方に<br/>
              お召し上がりいただけるように栄養士が開発
            </p>
            <hr css={style}/>
            <div css={comment}>
              エネルギーや塩分のコントロールだけでなく、咀嚼・嚥下が困難な方におすすめです。
              全てごはん付きの商品であり、塩分を2.0g未満に、エネルギーを500kcal未満に調整してあります。
            </div>
          </div>
        </MuiDialog>
      </>
  );
};

export default Care;

const dialogStyle = css`
  border-radius: 16px;
`

const cursor = css`
  cursor: pointer;
`

const style = css`
  border-top: solid 1px ${colorPalette.itemCategories.care};
`

const title = css`
  font-size: 32px;
  margin-bottom: 16px;
  text-align: center;
  color: ${colorPalette.itemCategories.care};
`

const subTitle = css`
  font-size: 24px;
  text-align: center;
  color: ${colorPalette.itemCategories.care};
`

const innerBox = css`
  max-width: 640px;
  padding: 32px 24px;
  margin: 16px auto 0;
`

const comment = css`
  margin-top: 24px;
`